import { Box } from "@mui/material";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import ScrollToTop from "@/app/ui/ScrollToTop";
import { AppToaster } from "@/shared/ui/AppToast";
import ScrollFadeBar from "@/app/ui/ScrollFadeBar";
import { RouteProgressProvider } from "@/app/ui/RouteProgress";
import MainLayout from "./layout/MainLayout";

import "./app/axiosSetup"; // Make sure to import the interceptor setup
import { useAppDispatch, useAppSelector } from "./app/hooks";
import AppRouter from "./app/router/AppRouter";
import { activityTracking } from "@/features/auth";
import { TermsAccess } from "@/features/terms";

const App: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { isAuthorized, signMsg, signature } = useAppSelector(
    (state) => state.auth
  );

  useEffect(() => {
    if (!isAuthorized || !signMsg || !signature) return;

    dispatch(activityTracking());
  }, [dispatch, isAuthorized, location, signMsg, signature]);

  return (
    <TermsAccess>
      <RouteProgressProvider>
        <Box>
          <MainLayout>
            <ScrollToTop />
            <AppRouter />
          </MainLayout>
          <AppToaster />
          <ScrollFadeBar />
        </Box>
      </RouteProgressProvider>
    </TermsAccess>
  );
};

export default App;
